// Centralized Data Layer for Laz Metals Corporate Website
// Information derived strictly from IDocs/core/COPYWRITING.md

export const navigationLinks = [
    { label: 'nav.home', href: '/' },
    { label: 'nav.services', href: '/servicios' },
    { label: 'nav.catalog', href: '/catalogo' },
    { label: 'nav.about', href: '/nosotros' },
    { label: 'nav.contact', href: '/contacto' },
];

export const heroContent = {
    eyebrow: 'EL ESLABÓN FUERTE DE LA INDUSTRIA METALÚRGICA AMERICANA.',
    title: 'Líderes en Reciclaje, Compra y Distribución Logística de Metales.',
    subtitle: 'Transformamos los pasivos ambientales y el excedente industrial en recursos productivos estratégicos. Desplegamos logística pesada para la recolección, compra directa de chatarra y garantizamos el suministro continuo de materia prima clasificada para mantener operativa tu fundición, sin excusas ni intermediarios.',
    primaryCta: 'Cotizar Compra / Venta',
    secondaryCta: 'Hablar con un Asesor Comercial',
};

export const trustIndicators = [
    { icon: 'Truck', text: 'trust.coverage' },
    { icon: 'Scale', text: 'trust.transaction' },
    { icon: 'RefreshCcw', text: 'trust.guarantee' },
];

export const catalogFerrous = [
    {
        title: 'catalogData.f1Title',
        description: 'catalogData.f1Desc',
        image: '/images/Catalogo/acero-hms1-chatarra-pesada-de-acero-limpia.webp',
    },
    {
        title: 'catalogData.f2Title',
        description: 'catalogData.f2Desc',
        image: '/images/Catalogo/acero-hms2-chatarra-pesada-con-galvanizado-selecto.jpg',
    },
    {
        title: 'catalogData.f3Title',
        description: 'catalogData.f3Desc',
        image: '/images/Catalogo/acero-en-palanquilla-bloques-solidos-destinados-a-la-forja.jpg',
    },
    {
        title: 'catalogData.f4Title',
        description: 'catalogData.f4Desc',
        image: '/images/Catalogo/acero-inoxidable-304-grado-estandar-resistente-a-la-corrosion.png',
    },
    {
        title: 'catalogData.f5Title',
        description: 'catalogData.f5Desc',
        image: '/images/Catalogo/acero-inoxidable-316.jpg',
    }
];

export const catalogNonFerrous = {
    'catalogData.catCopper': [
        { label: 'catalogData.nfCopper1', img: '/images/Catalogo/cable-de-cobre-brillante-millo.jpg' },
        { label: 'catalogData.nfCopper2', img: '/images/Catalogo/tuberia-de-cobre.jpg' },
        { label: 'catalogData.nfCopper3', img: '/images/Catalogo/cobre-mixto.jpg' },
        { label: 'catalogData.nfCopper4', img: '/images/Catalogo/lingote-de-cobre.jpg' }
    ],
    'catalogData.catAluminum': [
        { label: 'catalogData.nfAlum1', img: '/images/Catalogo/lingote-de-aluminio.webp' },
        { label: 'catalogData.nfAlum2', img: '/images/Catalogo/chatarra-de-aluminio.webp' },
        { label: 'catalogData.nfAlum3', img: '/images/Catalogo/latas-de-aluminio.jpg' },
        { label: 'catalogData.nfAlum4', img: '/images/Catalogo/rines-ruedas-de-aluminio.webp' }
    ],
    'catalogData.catBrass': [
        { label: 'catalogData.nfBrass1', img: '/images/Catalogo/laton-en-general-herrajes-conexiones.jpg' },
        { label: 'catalogData.nfBrass2', img: '/images/Catalogo/tuberia-de-laton.png' },
        { label: 'catalogData.nfBrass3', img: '/images/Catalogo/lingote-de-laton.jpeg' }
    ],
    'catalogData.catZinc': [
        { label: 'catalogData.nfZinc1', img: '/images/Catalogo/zinc-fundido-a-presion.jpeg' },
        { label: 'catalogData.nfZinc2', img: '/images/Catalogo/niquel.jpeg' }
    ],
    'catalogData.catRadiators': [
        { label: 'catalogData.nfRad1', img: '/images/Catalogo/radiadores-limpios.webp' },
        { label: 'catalogData.nfRad2', img: '/images/Catalogo/baterias-de-auto-y-camion.jpg' }
    ]
};
